import { Component } from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {DxPopupModule} from "devextreme-angular";
import {IfDebugModeDirective} from "../../../../../../@shared/loading-directive/if-debug-mode.directive";
import {MatTabsModule} from "@angular/material/tabs";
import {FormsModule} from "@angular/forms";
import {MatInputModule} from "@angular/material/input";
import {NgForOf} from "@angular/common";
import {
  ToolbarToolService
} from "@app/components-fuse/layout/components/toolbar/toolbar-tool-popup/toolbar-tool.service";
import {LoadingDirectiveModule} from "../../../../../../@shared/loading-directive/loading-directive.module";

@Component({
  selector: 'app-toolbar-tool-popup',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    DxPopupModule,
    IfDebugModeDirective,
    MatTabsModule,
    FormsModule,
    MatInputModule,
    NgForOf,
    LoadingDirectiveModule
  ],
  templateUrl: './toolbar-tool-popup.component.html',
  styleUrl: './toolbar-tool-popup.component.scss'
})
export class ToolbarToolPopupComponent {

  isVisible = false;
  backendPath: string;
  action: string;
  paramsBackEnd: Array<Array<string>> = [];

  constructor(
    public toolbarToolService: ToolbarToolService,
  ) {
  }


  workItUpWhoop(){
    this.isVisible = !this.isVisible;
  }

  addParamsBackEnd(){
    this.paramsBackEnd.push(['', '']);
  }

  removeParamsBackEnd(index: number){
    this.paramsBackEnd.splice(index, 1);
  }

  protected readonly ToolbarToolService = ToolbarToolService;
}
